import { getGridSingleSelectOperators } from '@mui/x-data-grid-pro';

import { getFilteredOperators } from '../get-filtered-operators';

// Must match: https://github.com/mui/mui-x/blob/master/packages/x-data-grid/src/colDef/gridSingleSelectOperators.ts
export enum GridSelectOperator {
  Is = 'is',
  Not = 'not',
  isAnyOf = 'isAnyOf',
}

export const getGridSelectOperators = () => getGridSingleSelectOperators();

export const getFilteredGridSelectOperators = (
  allowedOperators: GridSelectOperator[],
) => getFilteredOperators(getGridSelectOperators(), allowedOperators);
